export default __webpack_public_path__ + "static/coloredited_danalim_data_foothill-a929f2792aaeebaf8f3d547508a686a7.png";